import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeCtx = createContext({ darkMode: false, toggleDarkMode: () => {} });

export function ThemeAnbieter({ children }) {
  const [darkMode, setDarkMode] = useState(() => localStorage.getItem('portal_darkMode') === 'true');

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', darkMode ? 'dark' : 'light');
    localStorage.setItem('portal_darkMode', String(darkMode));
  }, [darkMode]);

  const toggleDarkMode = () => setDarkMode((p) => !p);

  return (
    <ThemeCtx.Provider value={{ darkMode, toggleDarkMode }}>
      {children}
    </ThemeCtx.Provider>
  );
}

export function useThemeMode() {
  return useContext(ThemeCtx);
}
